<ish-content-design-view-wrapper [slotId]="slot()" [pagelet]="pagelet()">
  @if (wrapper()) {
  <ng-content />
  } @else { @for (pagelet of pagelet().slot(slot()).pageletIDs; track pagelet) {
  <ish-content-pagelet [pageletId]="pagelet" />
  } }
</ish-content-design-view-wrapper>
